import { wineNaming } from "@/js/wine/wine.js";
export default {
  name: "wineNaming",
  props: {
    wineNamingData: Object,
    isPrefixWinery: Boolean,
    isSuffixBottling: Boolean,
    isSuffixType: Boolean,
    boolRender: Boolean
  },
  data: function data() {
    return {
      wineName: ""
    };
  },
  created: function created() {
    this.wineName = wineNaming(this.$whitelabel, this.wineNamingData, this.isPrefixWinery, this.isSuffixBottling, this.isSuffixType);
  }
};